import React, { useState } from 'react';
import { Typography, Upload, Button, message, Image, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Logo = () => {
  const [fileList, setFileList] = useState([]);
  const [imageUrl, setImageUrl] = useState('https://excintec.com/sat/assets/img/logo/logo.png');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const props = {
    onRemove: () => {
      setFileList([]);
      setError(null);
    },
    beforeUpload: (file) => {
      // Reset any previous errors
      setError(null);
      
      // Check file type
      if (!file.type.startsWith('image/')) {
        setError(`${file.name} is not an image file`);
        message.error(`${file.name} is not an image file`);
        return Upload.LIST_IGNORE;
      }
      
      // Check file size (limit to 2MB)
      if (file.size > 2 * 1024 * 1024) {
        setError(`${file.name} exceeds 2MB size limit`);
        message.error(`${file.name} exceeds 2MB size limit`);
        return Upload.LIST_IGNORE;
      }
      
      setFileList([file]);
      
      // Create a preview URL
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setImageUrl(reader.result);
      };
      
      return false;
    },
    fileList,
  };

  const handleUpload = () => {
    if (fileList.length === 0) {
      return;
    }
    
    setUploading(true);
    
    // Simulate upload with timeout
    setTimeout(() => {
      // In a real app, you would upload the file to your server here
      // const formData = new FormData();
      // formData.append('logo', fileList[0]);
      // fetch('/api/upload-logo', { method: 'POST', body: formData })
      
      setUploading(false);
      message.success('Logo uploaded successfully!');
    }, 1500);
  };

  return (
    <div>
      <Title level={2}>Website Logo</Title>
      <Card>
        <div style={{ marginBottom: 20 }}>
          <Title level={4}>Current Logo</Title>
          <Image
            width={200}
            src={imageUrl}
            alt="Logo"
          />
        </div>
        
        <Upload {...props} maxCount={1} accept="image/*">
          <Button icon={<UploadOutlined />}>Select New Logo</Button>
        </Upload>
        
        {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
        
        <div style={{ marginTop: 16 }}>
          <Button
            type="primary"
            onClick={handleUpload}
            disabled={fileList.length === 0 || uploading}
            loading={uploading}
          >
            {uploading ? 'Uploading...' : 'Upload Logo'}
          </Button>
          <div style={{ marginTop: 8, fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)' }}>
            Recommended: PNG or JPG format, max 2MB, with transparent background
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Logo; 